// reference: https://composition-api.nuxtjs.org/typings/definitionHelpers#definenuxtmiddleware
import { bookingEngineSubdomains, useBookingEngineData } from '~/composition/use-booking-engine'

// global middleware, 每一次換頁都會跑這裡
export default defineNuxtRouteMiddleware((to, from) => {
  const nuxtApp = useNuxtApp()
  const store = nuxtApp.$store
  const route = to

  if (to.query.subdomain) {
    const { subdomain, ...query } = to.query
    return navigateTo({ path: to.path, query }, { replace: true })
  }

  const req = useRequestURL()
  const config = useRuntimeConfig()
  // fb login, 'auth-fb-login'
  // branches index, 'branches-id___en'
  // booking index, '/booking/:id' '/booking/:id' => name: `booking-id___{lang}`
  // order list, 'orders-list___en'
  // order info, 'orders-info-id___en'
  const bookingEnginePathRegex = /^(branches|booking|orders|auth).*(___.+)$/g
  const isBookingEngineValidRoute = bookingEnginePathRegex.test(route.name)
  const envSubdomain = config.public.BOOKING_ENGINE_DOMAIN

  const host = req.host
  // handle store state from subdomain
  const tenantName = (!host.startsWith('www') && host.includes(envSubdomain) && host.split(envSubdomain)[0]) || ''
  store.commit('SET_TENANT_NAME', tenantName)

  const isSubdomainHost = bookingEngineSubdomains.value.includes(tenantName)
  /** @type {string} */
  const subdomainQueryString = to.query.subdomain

  const { bookingData } = useBookingEngineData(subdomainQueryString, store)

  if (store.state.branch?.branch?.funbook_ver === 2 || !bookingData.value.branchId) {
    return
  }

  // 以下都是 booking engine 的情況下 (已經不需要 subdomain query string)
  const bookingEngineBranchPath = `/funbook/${bookingData.value.branchId}/branch`
  if (isSubdomainHost) {
    const { subdomain, ...query } = route.query
    return navigateTo({ path: config.public.BASE_URL + bookingEngineBranchPath, query }, { redirectCode: 301, external: true })
  }
  // myfunnow main domain scope
  if (!isBookingEngineValidRoute) {
    // bookingEngine 的狀態下，到不能看的頁面，導回首頁
    return navigateTo({ path: nuxtApp.$localePath(bookingEngineBranchPath) }, { replace: true })
  }
})
